import { StripePaymentIntent } from "./payment-intent.model"

export interface UserPackageResponseModel extends PackageRecommendationModel {
    userId: string,
    createdAt: string,
    startDate: string,
    endDate: string,
    invoiceId: string
    packageId: string,
    packageName: string,
    status: string,
    paymentOption?: string,
    balance: string,
    coursesLeft: string,
    userPackageId: string,
    price: number,
    regularPrice: number,
    canRequestCancellation?: boolean,
    cancellationRequestedAt?: string
}

export interface PackageRecommendationModel extends PackageRecommendationRequestModel {
    packageId: string,
    tutorTypeText: string,
    regularPrice: number,
    name: string
    discountId: number,
    discountPercent: number,
    discountPercentInt: string,
    price: number,
    credits: number
    totalLessons: number,
    beforeHourlyPrice: number
    lessonPrice: number,
    tutorCategory: string,
    maxDurationMonths: number,
    totalDiscountAmount: number,
    packageName?: string,
    freeLessonAmount: number,
    freeLessonCount: string,
    amountForDiscountPercent: string,
    pricePerMonth: number,
    examPackage?: boolean,
    pricePerInstallment?: number,
    regularPricePerInstallment?: number,
    endDate?: string,
    tutorCategoryText?: string,
    summerBonusMonths?: number,
}
export interface PackageSubscriptionRequestModel {
    improvementPurpose: string
    packageId: string
    lessonsPerMonth: string
    tutorCategory: string
    durationMonths: string
    paymentOption: number
    discountPercentInt?: string
    examPackage?: boolean
    installmentOption?: InstallmentOptionEnum,
    totalInstallment?: number,
}

export interface ExamSubscriptionRequestModel {
    tutorCategory: string
    paymentOption: number
    installmentOption?: InstallmentOptionEnum
    totalInstallment?: number,
}

export enum InstallmentOptionEnum {
    single = 'single',
    multi = 'multi'
}

export enum PaymentMethodEnum {
    single = 2,
    multi = 3
}

export interface PackageRecommendationRequestModel {
    durationMonths: string,
    lessonsPerMonth: string,
    tutorCategory: string,
    country: string,
    totalInstallment?: number,
}

export interface PackageLinkModel {
    token: string,
    userId?: number,
    country: string,
    lessonsPerMonth: number,
    durationMonths?: number,
    tutorCategory: number,
    createdAt: string,
    expiresAt: string,
}

export interface UserPackages {
    packages: Array<UserPackageResponseModel>
}

export interface PackageDetails {
    durationMonths: string;
    endDate?: string;
    savePerMonth?: string;
    lessonsPerMonth?: string;
    costPerHour?: string;
    tutorCategory?: string;
    packageId?: string;
    pricePerMonth?: number;
    oldPricePerMonth?: number;
    discountPercentInt?: string;
    installmentOption?: InstallmentOptionEnum;
    examPackage?: boolean;
    totalInstallment?: string
    pricePerInstallment?: any;
    _model?: any;
    _totalPrice?: number;
    _totalLessonsInHours?: number;
    _badgeName?: string;
    _isExamPackageVersion?: boolean;
}

export interface PackageDataModel {
    userPackage: UserPackageResponseModel,
    paymentIntent: StripePaymentIntent,
    amountPaid: number,
    amountOutstanding: number
}

export interface FrequencyOption {
    text: string,
    value: string,
}
export interface SenorityOption {
    text: string,
    level: string,
}

export type InfoCard = {
    text: string,
    icon: string
}